__turbopack_context__.v({
  "desktop": "responsive-module-scss-module__adY9BG__desktop",
  "mobile": "responsive-module-scss-module__adY9BG__mobile",
});
